import React from 'react';
import SelectAllOffRegular from 'mini-fluent-svg-icons/lib/icons/SelectAllOffRegular';
import SelectAllOnRegular from 'mini-fluent-svg-icons/lib/icons/SelectAllOnRegular';
import styles from './SelectAllIcon.scss';
import { FluentSvgIcon } from 'mini-fluent-svg-icons/lib/components/FluentSvgIcon';

interface SelectAllIconProps {
    isAllSelected?: boolean;
    toggleText?: string;
    classNames?: boolean;
}

export const SelectAllIcon: React.FC<SelectAllIconProps> = props => {
    const { isAllSelected, toggleText } = props;

    return (
        <div className={styles.selectAllToggle}>
            <FluentSvgIcon
                icon={isAllSelected ? SelectAllOnRegular : SelectAllOffRegular}
                iconContainerStyles={styles.selectAllIcon}
            />
            <div className={styles.selectAllToggleText}>{toggleText}</div>
        </div>
    );
};
